// In frontend/src/components/layout/Footer.tsx

import { useSiteSettingsStore } from '@/store/settingsStore';

const Footer = () => {
  // Fetch settings from the Zustand store
  // FIX: Changed state.publicSettings?.site_title to state.publicSettings?.site_name
  const siteName = useSiteSettingsStore(state => state.publicSettings?.site_name);

  return (
    <footer className="bg-muted text-muted-foreground py-8 border-t">
      <div className="container mx-auto px-4 text-center">
        {/* The copyright now uses the dynamic site name or a fallback */}
        <p>&copy; {new Date().getFullYear()} {siteName || 'CoreCMS'}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;